<template>
    <div>
        <!-- Reject Purchase -->
        <v-card :loading="loading">
            <v-card-title class="text-h5">Reject</v-card-title>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12">
                        <p
                            v-if="validateWhetherDeliveriesExist"
                            class="my-0 py-0"
                        >
                            <strong
                                >There are registered entries in the purchase.
                                Material reception and invoice associations will
                                be preserved.</strong
                            >
                        </p>
                        <p>
                            Write the reasons why you decide to reject this
                            requisition
                        </p>
                    </v-col>
                </v-row>
                <v-form>
                    <v-row no-gutters class="mb-2 mt-n5">
                        <v-col cols="12">
                            <v-textarea
                                v-model="rejectedNotes"
                                rows="2"
                                hide-details
                                label="Notes"
                                prepend-icon="mdi-text"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="secondary" @click="closeDialog">
                    Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    @click="rejectRequest"
                    text
                    color="error"
                    :loading="loading"
                    :disabled="!rejectedNotes"
                >
                    Reject
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import API from '@/services/api'

export default {
    name: 'RejectPurchase',
    props: {
        request: Object,
    },
    data() {
        return {
            rejectedNotes: undefined,
            loading: false,
        }
    },
    computed: {
        validateWhetherDeliveriesExist() {
            for (const item of this.request.items || []) {
                if (item.entries && item.entries.length > 0) {
                    return true
                }
            }
            return false
        },
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog')
        },
        async rejectRequest() {
            try {
                this.loading = true
                await API.rejectPurchaseRequest(this.request.id, {
                    status: 'rejected',
                    notificationId: 'JQqZl0uGjBJCk450YrZ3',
                    rejectedNotes: this.rejectedNotes,
                })
                this.$emit('rejectRequest', this.request)
                this.closeDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.rejectedNotes = undefined
            }
        },
    },
}
</script>
